import { Message } from "../../../Services/MessageBus/Message";


export class ReadChatQuery extends Message
{
	constructor(Id: string, Folder: string)
	{
		super("Read", { Id, Folder });
	}
}
